import { TimerState } from "../store/timerSlice";

const initialTimerState: TimerState = {
  timedToday: 0,
  currentDate: new Date().getTime(),
  history: []
};

export default initialTimerState;
